//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.9.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum Flags {
    Multitenancy = "Multitenancy",
    Should_Convert_Videos = "Should_Convert_Videos",
    Show_BM_Response_On_Xml_Upload = "Show_BM_Response_On_Xml_Upload",
    Use_Azure_SignalR_Service = "Use_Azure_SignalR_Service",
    Show_Translation_Keys_Option_In_Language_Dropdown = "Show_Translation_Keys_Option_In_Language_Dropdown",
    Show_Page_Report_Templates = "Show_Page_Report_Templates",
    Show_Page_Deleted_Data = "Show_Page_Deleted_Data",
    Use_Custom_Report_Template_For_Project = "Use_Custom_Report_Template_For_Project",
    Render_VA_Diagram_In_Platform = "Render_VA_Diagram_In_Platform",
    Show_Video_Segmentations = "Show_Video_Segmentations",
    Upload_Files_Individually_On_Inspection_Files_Page = "Upload_Files_Individually_On_Inspection_Files_Page",
    Use_Development_Translation = "Use_Development_Translation",
    Show_Confidence_Level_Controls = "Show_Confidence_Level_Controls",
    Show_Pipe_Graph = "Show_Pipe_Graph",
}
